import AccountApi from '@/services/AccountApi'
import { LOGIN, LOGINAS, LOGOUT, INIT, WHOAMI } from './mutations-type.js'

const moduleAccount = {
  namespaced: true,
  state: {
    credentials: {
      token: null,
      whoAmI: null
    },
    initialize: false
  },
  actions: {
    Initialize (context) {
      return new Promise((resolve, reject) => {
        if (!context.getters['isInit']) {
          context.commit(INIT)
        }
        resolve()
      })
    },
    async login ({ commit, state }, data) {
      commit(LOGIN, { ...data })
    },
    async loginAs ({ commit, state }, data) {
      commit(LOGINAS, { ...data })
    },
    init (context) {
      context.commit(INIT)
    },
    logout (context) {
      context.commit(LOGOUT)
    },
    async askWhoAmI (context) {
      var api = new AccountApi()
      var whoAmI = await api.whoAmI()
      var data = { whoAmI: whoAmI }
      context.commit(WHOAMI, { ...data })
      return whoAmI
    }
  },
  mutations: {
    [LOGIN] (state, { token }) {
      state.credentials = {
        token,
        whoAmI: null
      }
    },
    [LOGOUT] (state) {
      state.credentials = null
    },
    [INIT] (state) {
      const stringState = localStorage.getItem('state')
      if (stringState) {
        const newState = JSON.parse(stringState)
        state.initialize = true
        state.credentials = newState.account.credentials
      }
    },
    [WHOAMI] (state, { whoAmI }) {
      state.credentials.whoAmI = whoAmI
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.credentials !== null &&
        state.credentials.token !== null
    },
    isInit (state) {
      return state.initialize
    },
    token (state, getters) {
      if (getters.isAuthenticated) {
        return state.credentials.token
      } else {
        return ''
      }
    },
    whoAmI (state) {
      if (state.credentials == null) return
      return state.credentials.whoAmI
    }
  }
}

export default moduleAccount



// WEBPACK FOOTER //
// ./src/store/account/index.js